import { createContext } from 'react'

export interface SaveQueueState {
  isSaving: boolean
  lastSaved: Date | null
  saveError: Error | null
  pendingSaveCount: number
}

export interface SaveQueueContextValue {
  // State
  saveState: SaveQueueState

  // Methods
  enqueueSave: (saveFunction: () => Promise<void>, debounceMs?: number) => void
  waitForPendingSaves: () => Promise<void>
  cancelPendingSaves: () => void
  flushDebounce: () => void // Execute pending debounced save immediately (if any)
}

export const SaveQueueContext = createContext<SaveQueueContextValue | null>(null)
